import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMapUrl } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { colors } from '../styles';

const styles = css`
  width: calc(100% - 30px);
  max-width: 380px;
  margin: 0 15px 90px 15px;
  display: flex;
  .CommunityContactCard {
    width: 100%;
    text-align: left;
    padding: 0 45px 0 0;
    @media (min-width: 992px) {
      padding: 0 60px 0 0;
    }
  }
  .CommunityContactCard_name {
    font-size: 21px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0;
    line-height: 1;
    margin: 0 0 5px 0;
    @media (min-width: 992px) {
      font-size: 23px;
    }
  }
  .CommunityContactCard_city {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0;
    line-height: 1;
    margin: 0 0 20px 0;
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .CommunityContactCard_phone {
    padding: 0 0 0 40px;
    margin: 0 0 30px 0;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: -2px;
      left: 5px;
      width: 25px;
      height: 30px;
      background-image: url('/images/icon-phone-light-blue.svg');
      background-position: left top;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  .CommunityContactCard_address {
    padding: 0 0 0 40px;
    margin: 0 0 30px 0;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 2px;
      left: 0;
      width: 25px;
      height: 35px;
      background-image: url('/images/icon-map-pin-outline-light-blue.svg');
      background-position: left top;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  .CommunityContactCard_agent {
    padding: 0 0 0 40px;
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: -5px;
      left: 0;
      width: 25px;
      height: 35px;
      background-image: url('/images/icon-email-light-blue.svg');
      background-position: left top;
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
  .CommunityContactCard_link {
    text-decoration: underline;
    margin-left: 8px;
  }
`;


function CommunityContactCards({ community, agent }) {
  return (
    <div className={styles}>
      <div className="CommunityContactCard">
        <div className="CommunityContactCard_content">
          <h4 className="CommunityContactCard_name">{get(community, 'name')}</h4>
          <h5 className="CommunityContactCard_city">{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</h5>
          {
            get(community, 'telephone') &&
            <div className="CommunityContactCard_phone">
              Call <a href={`tel:${get(community, 'telephone').replace(/[^0-9]/g, '')}`}>{get(community, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}</a>
            </div>
          }
          {
            get(community, 'address.streetAddress') &&
            <div className="CommunityContactCard_address">
              {get(community, 'address.streetAddress')}<br />
              {get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}
              <a href={GoogleMapUrl(community)} className="CommunityContactCard_link" target="_blank" rel="noopener noreferrer" title="View office location on Google map">
                MAP
              </a>
            </div>
          }
          {
            get(agent, 'email') &&
            <div className="CommunityContactCard_agent">
              {get(agent, 'name')}
              <a href={`mailto:${get(agent, 'email')}`} className="CommunityContactCard_link">EMAIL</a>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

CommunityContactCards.propTypes = {
  community: PropTypes.object.isRequired,
  agent: PropTypes.object.isRequired,
};

export default withData({
  community: 'true',
  agent: 'true',
})(CommunityContactCards);



// WEBPACK FOOTER //
// ./src/components/CommunityContactCard.js